



























































































import { Component, Vue } from 'vue-property-decorator';
   @Component({ 
    })


export default class AddPenaltyRule extends Vue   {

 dialog:boolean= true;

  data () {
      return {
        companiesItems: ['REDWINGS','TÜRK HAVA YOLLARI'],
        companies: [],

        segmentsItems: ['Y'],
        segments: [],

        calculationItems:['Oran','Miktar'],
        calculation: [],



        range: [0, 70],
      }
    }
 

    closeDialog(){
      this.$emit('closed');
     
    }



};
